import React from 'react';
import PropTypes from 'prop-types';

const Render = ({ shouldRender, children }) => <> {shouldRender && children}</>;

Render.propTypes = {
  shouldRender: PropTypes.bool,
  children: PropTypes.node,
};

export default Render;
